<app-background></app-background>

<div class="main fade-in">
        <div class="section-header">
                <div class="heading">
                        core modules
                </div>
                <div class="description">
                        modules for each of the core business functions
                </div>
        </div>
        <div class="dashboard">
                <submodule-card *ngFor="let module of (moduleCards$ | async)" [card]="module"></submodule-card>
        </div>
        <div *ngIf="(moduleCards$ | async)?.length === 0" class="empty-section">
                you do not have access to any modules :(<br>please contact engineering to be granted access

        </div>
</div>